import { LandingSiteTemplateGetDataCommonDataSocialNetworkOutputApiModel } from "@/Apis/ClinicApi";
import SmartLink from "@/Components/SmartLink";
import { Icon } from "@iconify/react";
import { FC } from "react";

interface SocialNetworksProps {
    socialNetworks: LandingSiteTemplateGetDataCommonDataSocialNetworkOutputApiModel[];
    wrapWithLi?: boolean;
    linkClassName?: string;
}

const SocialNetworks: FC<SocialNetworksProps> = ({
    socialNetworks,
    wrapWithLi,
    linkClassName,
}) => {
    return socialNetworks.map((socialNetwork) => {
        const content = (
            <SmartLink
                className={linkClassName}
                href={socialNetwork.Link}
                key={socialNetwork.Id}
                title={socialNetwork.Name}
            >
                <Icon icon={socialNetwork.Icon} />
            </SmartLink>
        );
        return wrapWithLi ? <li key={socialNetwork.Id}>{content}</li> : content;
    });
};

export default SocialNetworks;
